<template>
  <TemplateConMenuLateral>
    <Banner
      slot="banner"
      titulo="Aviso de Renovación"
      style="flex: 1 0 100%,"
    />
    <div slot="contenido" class="tarjetario">
      <DatosAvisoRenovacion :avisoRenovacion="avisoRenovacion" />
    </div>
  </TemplateConMenuLateral>
</template>

<script>
export default {
  computed: {
    avisoRenovacion() {
      return this.$store.state.seleccion;
    },
  },

  beforeRouteEnter: async function(to, from, next) {
    await fetchData(to.params.idPoliza);
    next();
  },

  beforeRouteUpdate: async function(to, from, next) {
    await fetchData(to.params.idPoliza);
    next();
  },
  methods: {},
};

import store from "@/store/store.js";
async function fetchData(idPoliza) {
  await store.dispatch("getAvisoRenovacion", idPoliza);
}
</script>

<style lang="scss" scoped></style>
